import React, { Component } from "react";
import DisaggHeader from "./DisaggHeader";
import DisaggBody from "./DisaggBody";
import DisaggFooter from "./DisaggFooter";
import FooterMain from "../../common/Footer/FooterMain";

class DisaggMain extends Component {
  render() {
    return (
      <React.Fragment>
        <DisaggHeader translations={this.props.translations} configs={this.props.configs} userObj={this.props.userObj} />
        <DisaggBody translations={this.props.translations} configs={this.props.configs} userObj={this.props.userObj} />
        <DisaggFooter
          thumbsUpClick={() => this.props.onSubmitPositive()}
          thumbsDownClick={() => this.props.onSubmitNegative()}
          translations={this.props.translations} configs={this.props.configs}
        />
        {this.props.configs && this.props.configs.data && this.props.configs.data["DASHBOARD.PREFERENCE_PAGE.FOOTER.SHOW"] === "true" && this.props.translations && this.props.translations.data ?
          (<FooterMain
            configs={this.props.configs}
            translations={this.props.translations}
            footerNote={this.props.translations.data["FOOTER.FAQ_PAGE.FOOTER_NOTE"]}
            queryParams={this.props.queryParams}
            uuid={this.props.userObj.details.uuid}
          />)
          : ''
        }
      </React.Fragment>
    );
  }
}

export default DisaggMain;
